// extracted by mini-css-extract-plugin
export var actionButton = "_i5-0";
export var fileInput = "_i5-2";
export var paperclip = "_i5-1";